import { FC, createPortal } from "preact/compat";
import { useEffect } from "preact/hooks";
import { usePortalTarget } from "~/hooks";
import FloatingMenu from "./FloatingMenu";
import type { GhostsProps } from "./interfaces";
import { updateContentHeight } from "./utils";

const Ghosts: FC<GhostsProps> = ({ items }) => {
    const target = usePortalTarget();

    useEffect(() => {
        const tabs = document.querySelector<HTMLElement>(
            "[data-floating-tabs]",
        );

        if (!tabs) {
            return;
        }

        tabs.classList.remove("hidden");
        updateContentHeight(true);

        return () => {
            tabs.classList.add("hidden");

            if (tabs.style.display !== "block") {
                updateContentHeight(false);
            }
        };
    }, []);

    if (!target.value) {
        return null;
    }

    return createPortal(
        <>
            <FloatingMenu ghost items={items} id="left" />
            <FloatingMenu
                ghost
                items={items}
                id="bottom"
                defaultPosition={{
                    bottom: "12px",
                    left: "50%",
                    horizontal: true,
                }}
            />
            <FloatingMenu
                ghost
                items={items}
                id="right"
                defaultPosition={{
                    right: "12px",
                    top: "50%",
                }}
            />
        </>,
        target.value,
    );
};

export default Ghosts;
